import { prototype } from "events";
import type { Filter, FilterGroup } from "../types/types";

const sanitizeValue = (value: string | number | boolean) => {
    return value.toString().toLowerCase().replaceAll('\'', '\'\'');
}

const encodeValue = (value: string | number | boolean): string => {
    if (typeof value === 'boolean') {
        return value.toString();
    } else if (typeof value !== 'number') {
        return `'${sanitizeValue(value)}'`;
    }

    return value.toString();
}

export const SubstituteFilter = (filters: Filter[], filter: Filter): Filter[] => {
    filters = filters.filter((x: Filter) => x.property.toLowerCase() !== filter.property);
    filters.push(filter);
    return filters;
}

export const GenerateODataFilter = (filters: (Filter | FilterGroup)[], join?: 'and' | 'or'): string | undefined => {

    let filterString = "";
    let filterCombined: string[] = [];
    if (!join) {
        join = 'and';
    }

    filters.forEach((filter) => {
        if (filter.type === "group") {
            var filters = GenerateODataFilter(filter.filters, filter.join);
            filterCombined.push("(" + filters + ")");
        } else {
            if (filter.values.length > 0) {
                let filterValues: string[] = [];

                switch (filter.type) {
                    case "search":
                        [...filter.property.split(",")].forEach(property => {
                            let filtervalue = '';

                            const props = property.split(".");

                            let prefix = "";
                            let postfix = "";
                            let isMetadata = false;

                            for (let i = 0; i < props.length - 1; i++) {
                                const property = props[i];

                                if (property.endsWith("[]")) {
                                    prefix += property.replace("[]", "") + `/any(p${i}:p${i}/`;
                                    postfix = ")" + postfix;
                                } else if (property == "metadata") {
                                    prefix += property + '/any(';
                                    postfix = ")" + postfix;
                                } else {
                                    prefix += property + "/";
                                }

                                if (property == "metadata") {
                                    isMetadata = true;
                                    break;
                                }
                            }

                            let field = props[props.length - 1];


                            if (isMetadata) {
                                if (filter.caseSensitive) {
                                    filtervalue = `${prefix}p:p/Name eq '${field.toLowerCase()}' and ${filter.values.map(e => e.value).reduce((prev, curr, index) => prev += `${index > 0 ? ` or ` : ``}contains(p/Value,'${sanitizeValue(curr)}')`, "")}${postfix}`
                                } else {
                                    filtervalue = `${prefix}p:tolower(p/Name) eq '${field.toLowerCase()}' and ${filter.values.map(e => e.value).reduce((prev, curr, index) => prev += `${index > 0 ? ` or ` : ``}contains(tolower(p/Value),'${sanitizeValue(curr)}')`, "")}${postfix}`
                                }
                            } else {
                                filtervalue = `${prefix} contains(tolower(${property}),'${sanitizeValue(filter.values[0].value)}') ${postfix}`;
                            }

                            filterValues.push(filtervalue);
                        });

                        filterCombined.push(`(${filterValues.join(filter.negate ? " and " : " or ")})`);

                        break;
                    case "select":

                        [...filter.property.split(",")].forEach(property => {
                            let comparison = "";

                            if (filter.values.length > 1) {
                                comparison = `in (${filter.values.map(e => encodeValue(e.value)).join(',')})`
                                if (filter.negate) {
                                    comparison += ' eq false';
                                }
                            } else {
                                let val = encodeValue(filter.values[0].value);
                                comparison = (filter.negate ? "ne " : "eq ") + val;
                            }

                            var filtervalue = `${property} ${comparison}`;

                            if (property.indexOf(".") > 0) {
                                const props = property.split(".");

                                let prefix = "";
                                let postfix = "";
                                let metadataField = "";

                                for (let i = 0; i < props.length; i++) {
                                    const property = props[i];

                                    if (property.endsWith("[]")) {
                                        prefix += property.replace("[]", "") + `/any(p${i}:p${i}/`;
                                        postfix = ")" + postfix;
                                    } else if (property == "metadata") {
                                        prefix += property + '/any(';
                                        postfix = ")" + postfix;
                                    } else {
                                        prefix += property + "/";
                                    }

                                    if (property == "metadata") {
                                        metadataField = props[i + 1];
                                        break;
                                    }
                                }

                                if (metadataField != "") {
                                    if (filter.caseSensitive) {
                                        filtervalue = `${prefix}p:p/Name eq '${props[props.length - 1].toLowerCase()}' and p/Value ${comparison}${postfix}`
                                    } else {
                                        filtervalue = `${prefix}p:tolower(p/Name) eq '${props[props.length - 1].toLowerCase()}' and (tolower(p/Value) ${comparison})${postfix}`
                                    }
                                } else {
                                    filtervalue = prefix + comparison + postfix;
                                }
                            }

                            filterValues.push(filtervalue);
                        });

                        filterCombined.push(`(${filterValues.join(filter.negate ? " and " : " or ")})`)

                        break;

                    case "daterange":

                        filter.values.forEach((value, valueindex) => {
                            const comparer = (valueindex === 1) ? "lt" : "gt";
                            const dateValue = new Date(parseInt(value.value.toString())).toISOString()
                            filterValues.push(`${filter.property} ${comparer} ${dateValue}`);
                        });

                        filterCombined.push(`(${filterValues.join(" and ")})`)

                        break;

                    default:
                        const comparison = filter.negate ? "ne" : "eq";

                        filter.values.forEach(value => {
                            filterValues.push(`${filter.property} ${comparison} ${sanitizeValue(value.value)}`);
                        });

                        filterCombined.push(`(${filterValues.join(" or ")})`)
                        break;
                }
            }
        }
    });

    filterString = filterCombined.join(" " + join + " ");

    if (filterString.length === 0)
        return undefined;

    return filterString;
}